export default __webpack_public_path__ + "static/media/team-3@2x.e7b4fa2a.png";